import { EPermissionOption } from './model/models';

// Ensure that accessLevel contains all the access level specified in permission
export const hasPermission = (accessLevel: EPermissionOption, permission: any): boolean =>
  accessLevel >= permission;
